<template>

  <div>
    <div class="text-center">
      <a href="#" @click="show = true" style="line-height: 35px;">Pago inicial offline</a>
    </div>
    <vs-popup :active.sync="show" title="Pago inicial offline">
      <div>
        <div class="row">
          <div class="col-md-12">
            <p>Total: ${{formatPrice(amount)}}</p>
          </div>
        </div>
        <form  @submit.prevent="offline">
          <vs-input
              class="w-full"
              :disabled="loading"
              type="file"
              id="fund_evidence"
              label="Evidencia de pago 1 - Obligatoria"></vs-input>

          <vs-input
              class="w-full"
              :disabled="loading"
              type="file"
              id="fund_evidence2"
              label="Evidencia de pago 1 - Obligatoria"></vs-input>

          <div class="row">
            <div class="col-md-12 text-right mt-6">
              <vs-button :disabled="loading">Ejecutar</vs-button>
            </div>
          </div>
          <div class="row" v-if="loading">
            <div class="col-md-12 text-center">
              <div class="loader-spinner"></div>
            </div>
          </div>
        </form>


      </div>
    </vs-popup>
  </div>

</template>

<script lang="js">
  import {mapState} from "vuex";
  import {formatPrice} from '../../filters.js';
  export default  {
    name: 'project-initial-payment-offline',
    props: ['project_id', 'amount'],
    mounted() {

    },
    data() {
      return {
        loading: false,
        show: false
      }
    },
    methods: {
      formatPrice,
      async offline(){
        try{
          var evidence = document.getElementById('fund_evidence');
          var evidence2 = document.getElementById('fund_evidence2');
          if(evidence.files.length == 0){
              alert('Agrega una evidencia de pago.')
              return 0;
          }
          if(this.amount > 0){
             var fa =  prompt('Ejecución de pago inicial en cuenta concentradora.\nMonto: $'+this.formatPrice(this.amount)+'\nConfirma con tu segundo factor de autenticación:', '');
              if(fa !=  null && fa != ''){
                this.loading = true
                var data = new FormData();
                data.append("amount", this.amount);
                data.append("project_id", this.project_id);
                data.append("code", fa);
                data.append("evidence", evidence.files[0]);
                if(evidence2.files.length > 0){
                    data.append("evidence2", evidence2.files[0]);
                }
                var response = await axios.post('/api/project/initial_payment/offline', data);

                this.loading = false
                this.show = false
                swal("Ok!", "Se ha ejecutado el pago inicial", "success");
              }

          }
        }catch(error){
          if(error.response != undefined && error.response.data != undefined && error.response.data.message != undefined){
            swal("Ups!", error.response.data.message, "error")

          }else{
            swal("Ups!", 'Ha ocurrido un error intente mas tarde.', "error")
          }
        }
        this.loading = false
      }

    },
    computed: {
      ...mapState('auth', ['user']),
    }
}
</script>

<style scoped lang="scss">
  .project-initial-payment-offline {

  }
  .loader-spinner {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 0.5s linear infinite;
    -webkit-animation: spin 0.5s linear infinite;
    margin: 10px auto;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
</style>
